import { RootState } from 'store';
import { useCallback, useMemo } from 'react';

import { useSelector } from 'react-redux';
import {
  checkIsLoading,
  checkIsLoadingDone,
  checkIsLoadingError
} from 'common/utils/checkLoading';

import { EMPTY_ARRAY } from 'common/constants';
import { BRANDS_STATE } from '../../constants';

export const useFavouriteBrands = () => {
  const favouriteBrands = useSelector((state: RootState) => state[BRANDS_STATE].favouriteBrands.data);
  return favouriteBrands;
};

export const useIsExistFavouriteBrandByCode = (brandCode: string = '') => {
  const favouriteBrands = useFavouriteBrands();

  const isExistFavouriteBrand = useMemo(() => (
    !!(favouriteBrands || []).find(item => item.title === brandCode)
  ), [
    favouriteBrands,
    brandCode
  ]);

  return isExistFavouriteBrand;
};

export const useCheckIsExistFavouriteBrandByCode = () => {
  const favouriteBrands = useFavouriteBrands();

  const checkIsExistFavouriteBrand = useCallback((brandCode: string = '') => (
    !!(favouriteBrands || []).find(item => item.title === brandCode)
  ), [favouriteBrands]);

  return checkIsExistFavouriteBrand;
}

const useFavouriteBrandsLoadingStatus = () => {
  const favouriteBrandsLoadingStatus = useSelector((state: RootState) => state[BRANDS_STATE].favouriteBrands.loadingStatus);
  return favouriteBrandsLoadingStatus;
};

const useAddingFavouriteBrandsLoadingStatus = () => {
  const addingFavouriteBrandsLoadingStatus = useSelector((state: RootState) => state[BRANDS_STATE].favouriteBrands.addingStatus);
  return addingFavouriteBrandsLoadingStatus;
};

export const useIsAddingFavouriteBrandsLoading = () => {
  const addingFavouriteBrandsLoadingStatus = useAddingFavouriteBrandsLoadingStatus();
  return checkIsLoading(addingFavouriteBrandsLoadingStatus);
};

export const useIsAddingFavouriteBrandsDone = () => {
  const addingFavouriteBrandsLoadingStatus = useAddingFavouriteBrandsLoadingStatus();
  return checkIsLoadingDone(addingFavouriteBrandsLoadingStatus);
};

const useFavouriteBrandsDeletingStatus = () => {
  const favouriteBrandsDeletingStatus = useSelector((state: RootState) => state[BRANDS_STATE].favouriteBrands.deletingStatus);
  return favouriteBrandsDeletingStatus;
};

export const useIsDeletingFavouriteBrandsLoading = () => {
  const favouriteBrandsDeletingStatus = useFavouriteBrandsDeletingStatus();
  return checkIsLoading(favouriteBrandsDeletingStatus);
};

export const useIsDeletingFavouriteBrandsDone = () => {
  const favouriteBrandsDeletingStatus = useFavouriteBrandsDeletingStatus();
  return checkIsLoadingDone(favouriteBrandsDeletingStatus);
};

export const useFilterFavouriteBrandsByTitle = () => {
  const favouriteBrands = useFavouriteBrands() || EMPTY_ARRAY;

  const filterFavouriteBrandsByTitle = useCallback((brandTitle: string) => (
    favouriteBrands.filter(({ title }) => title.toLowerCase().includes(brandTitle.toLowerCase()))
  ), [favouriteBrands]);

  return filterFavouriteBrandsByTitle;
};

export const useIsFavouriteBrandsLoading = () => {
  const favouriteBrandsLoadingStatus = useFavouriteBrandsLoadingStatus();
  return checkIsLoading(favouriteBrandsLoadingStatus);
};

export const useIsFavouriteBrandsDone = () => {
  const favouriteBrandsLoadingStatus = useFavouriteBrandsLoadingStatus();
  return checkIsLoadingDone(favouriteBrandsLoadingStatus);
};

export const useIsFavouriteBrandsError = () => {
  const favouriteBrandsLoadingStatus = useFavouriteBrandsLoadingStatus();
  return checkIsLoadingError(favouriteBrandsLoadingStatus);
};